












































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import TransactionsDataTable from '@/components/TransactionsDataTable.vue';
import Ledger from '@/models/Ledger';
import LedgerStatusReason from '@/models/LedgerStatusReason';
import SkillType from '@/models/SkillType';

@Component({
  components: { TransactionsDataTable },
})
export default class LedgerDataTable extends Vue {
  @Prop({ default: [] }) items!: Ledger[];

  formatDate(dateString: string) {
    return moment(dateString).format('MMM D, YYYY');
  }

  formatMoney(money: string) {
    if (money == null || money === '') {
      return '$0.00';
    }

    return `$${money}`;
  }

  formatSkillType(type: keyof typeof SkillType) {
    return SkillType[type];
  }

  formatStatus(ledger: Ledger) {
    if (ledger.status === 'PENDING') {
      return 'Pending';
    }

    if (!ledger.statusReason) {
      return '';
    }

    return LedgerStatusReason[ledger.statusReason as keyof typeof LedgerStatusReason];
  }

  isExpandable(ledger: Ledger) {
    return ledger.transactions.length > 0;
  }
}
